module.exports = __webpack_public_path__ + "img/lilo-on-dark.66e7123c.png";